import { Droplet } from "lucide-react";
import React, { useState, useEffect } from "react";

import {
  colorToHex,
  getCurrentStyleTarget,
  runEditorCommand
} from "@/helpers/editor/command-style";

import { cn } from "@/lib/utils";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui/popover";

import ToolbarButton from "./toolbar-button";

interface Props extends React.ComponentProps<"button"> {
  editorRef: React.RefObject<HTMLDivElement>;
}

const TextHighlight: React.FC<Props> = ({ className, editorRef, ...props }) => {
  const [selectedColor, setSelectedColor] = useState("#FFFFFF");

  const getSelectedTextColor = () => {
    const styleTarget = getCurrentStyleTarget(editorRef);
    if (styleTarget) {
      const color = window.getComputedStyle(styleTarget).backgroundColor;
      return colorToHex(color, "#ffffff");
    }

    return "#FFFFFF";
  };

  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    setSelectedColor(color);

    runEditorCommand(editorRef, "backColor", color);
  };

  const updateSelectedTextColor = () => {
    const color = getSelectedTextColor();
    setSelectedColor(color);
  };

  useEffect(() => {
    if (editorRef.current) {
      editorRef.current.addEventListener("mouseup", updateSelectedTextColor);
      editorRef.current.addEventListener("keyup", updateSelectedTextColor);
    }

    return () => {
      if (editorRef.current) {
        editorRef.current.removeEventListener(
          "mouseup",
          updateSelectedTextColor
        );
        editorRef.current.removeEventListener("keyup", updateSelectedTextColor);
      }
    };
  }, [editorRef]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <ToolbarButton className={cn(className)} {...props}>
          <span className="w-full bg-yellow-300 text-lg">ab</span>
        </ToolbarButton>
      </PopoverTrigger>

      <PopoverContent className="w-64">
        <Input
          type="color"
          value={selectedColor}
          onChange={handleColorChange}
        />
        <Button
          variant="ghost"
          className="mt-2 w-full justify-start"
          onClick={() => {
            runEditorCommand(editorRef, "backColor", "transparent");
          }}
        >
          <Droplet />
          بدون هایلایت
        </Button>
      </PopoverContent>
    </Popover>
  );
};

export default TextHighlight;
